import ConfigProductInPackageScreen from "./ConfigProductInPackageScreen";
export default ConfigProductInPackageScreen;
